import { ImageLightbox } from './ImageLightbox';

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
};

export const Gallery = (props) => {
  const items = props.data || [];
  const hero     = items[0];
  const side1    = items[1];
  const side2    = items[2];
  const bottomRow = items.slice(3); // 6 images → 2 rows of 3

  return (
    <section id='portfolio' style={{ padding: '100px 0', background: '#fff' }}>
      <div className='container'>

        {/* ── Section Header ── */}
        <div style={{ marginBottom: '56px' }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: '24px' }}>

            {/* Left: headline */}
            <div>
              <p style={{
                color: '#5ca9fb', fontWeight: '700',
                fontSize: '12px', letterSpacing: '3px',
                textTransform: 'uppercase', margin: '0 0 14px',
              }}>
                — Our Work
              </p>
              <h2 style={{
                fontFamily: 'Raleway, sans-serif',
                fontSize: 'clamp(30px, 4vw, 50px)',
                fontWeight: '800', color: '#0f0f1a',
                lineHeight: '1.1', margin: 0,
              }}>
                Projects &amp;&nbsp;
                <span style={{ color: '#5ca9fb' }}>Gallery</span>
              </h2>
            </div>

            {/* Right: stats pills */}
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {[
                { value: '100+', label: 'Projects Completed' },
                { value: '20+',  label: 'Years Active' },
                { value: `${props.contact?.rating || '4.5'}★`, label: 'Google Rating' },
              ].map((s, i) => (
                <div key={i} style={{
                  padding: '10px 18px',
                  borderRadius: '50px',
                  background: '#f4f7ff',
                  border: '1px solid #e0e8ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minWidth: '86px',
                }}>
                  <span style={{
                    fontFamily: 'Raleway, sans-serif',
                    fontSize: '18px', fontWeight: '800',
                    color: '#5ca9fb', lineHeight: 1,
                  }}>{s.value}</span>
                  <span style={{
                    fontSize: '10px', fontWeight: '600',
                    color: '#aaa', textTransform: 'uppercase',
                    letterSpacing: '0.5px', marginTop: '3px',
                  }}>{s.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div style={{ marginTop: '32px', height: '1px', background: 'linear-gradient(to right, #5ca9fb22, #6372ff22, transparent)' }} />
        </div>

        {/* ── Editorial Top Block ── */}
        {items.length >= 3 && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr',
            gap: '12px',
            marginBottom: '12px',
            height: '500px',
          }}>
            {/* Hero — left, full height */}
            <div style={{ height: '500px' }}>
              <ImageLightbox
                title={hero.title}
                largeImage={hero.largeImage}
                smallImage={hero.smallImage}
              />
            </div>

            {/* Right column — two stacked */}
            <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', gap: '12px', height: '500px' }}>
              <ImageLightbox
                title={side1.title}
                largeImage={side1.largeImage}
                smallImage={side1.smallImage}
              />
              <ImageLightbox
                title={side2.title}
                largeImage={side2.largeImage}
                smallImage={side2.smallImage}
              />
            </div>
          </div>
        )}

        {/* ── Bottom 6-image Grid ── */}
        {bottomRow.length > 0 && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '12px',
          }}>
            {bottomRow.map((d, i) => (
              <div key={`${d.title}-${i}`} style={{ height: '220px' }}>
                <ImageLightbox
                  title={d.title}
                  largeImage={d.largeImage}
                  smallImage={d.smallImage}
                />
              </div>
            ))}
          </div>
        )}

        {/* ── CTA Strip ── */}
        <div style={{
          marginTop: '60px',
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)',
          padding: '48px 40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '28px',
        }}>
          <div>
            <p style={{
              color: '#5ca9fb', fontWeight: '700',
              fontSize: '11px', letterSpacing: '3px',
              textTransform: 'uppercase', margin: '0 0 10px',
            }}>
              — Want More?
            </p>
            <h3 style={{
              fontFamily: 'Raleway, sans-serif',
              fontSize: 'clamp(20px, 2.5vw, 28px)',
              fontWeight: '800', color: '#fff',
              margin: '0 0 8px', lineHeight: '1.2',
            }}>
              See Our Full Portfolio
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '14px', margin: 0 }}>
              Hundreds of completed jobs — browse our full photo album on Google Business.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <a
              href='https://www.google.com/maps/search/?api=1&query=ACTECH+Air+conditioning+Services+103+Olaitan+Odularu+St+Surulere+Lagos'
              target='_blank'
              rel='noopener noreferrer'
              className='gal-btn'
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                background: 'linear-gradient(to right, #5ca9fb, #6372ff)',
                color: '#fff', padding: '13px 26px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                boxShadow: '0 8px 24px rgba(92,169,251,0.4)',
                whiteSpace: 'nowrap',
              }}
            >
              <i className='fa fa-google'></i> View on Google
            </a>
            <a
              href='#contact'
              onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
              className='gal-btn'
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                color: '#fff', padding: '13px 26px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                border: '2px solid rgba(255,255,255,0.18)',
                whiteSpace: 'nowrap',
              }}
            >
              <i className='fa fa-calendar'></i> Book a Service
            </a>
          </div>
        </div>

      </div>

      <style>{`
        /* Reset FA icon blobs inside gallery buttons */
        #portfolio .gal-btn i.fa {
          font-size: 14px !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: none !important;
          box-shadow: none !important;
          margin-bottom: 0 !important;
          color: inherit !important;
          display: inline !important;
          transition: none !important;
          line-height: inherit !important;
        }

        @media (max-width: 768px) {
          #portfolio .gallery-top {
            grid-template-columns: 1fr !important;
            height: auto !important;
          }
        }

        @media (max-width: 640px) {
          #portfolio .gallery-bottom {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 420px) {
          #portfolio .gallery-bottom {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};
